module.exports = __webpack_public_path__ + "img/flower.a16a6acb.png";